import React from 'react';

type Props = {} & React.SVGProps<SVGSVGElement>;

const SmileyBad = (props: Props): JSX.Element => {
  return (
    // @ts-ignore
    <svg
      viewBox="0 0 35 35" {...props}
    >
      <path
        d="M17.5.247C7.972.247.247 7.972.247 17.5S7.971 34.753 17.5 34.753 34.753 27.028 34.753 17.5 27.028.247 17.5.247zm5.128 9.617a3.219 3.219 0 110 6.437 3.219 3.219 0 010-6.437zm-10.256-.283a3.219 3.219 0 110 6.437 3.219 3.219 0 010-6.437zm14.307 16.67a1.173 1.173 0 01-1.664 0c-3.412-3.411-12.13-2.899-15.03 0a1.176 1.176 0 11-1.664-1.664c1.783-1.784 5.171-2.962 8.84-3.075 3.97-.125 7.44.998 9.517 3.075.46.46.46 1.205.001 1.664z"
      />
    </svg>
  );
};

export default SmileyBad;
